export default {
  title: 'Thread Page',
  header: 'Thread'
}
